import { API_URL, API_URL_AGENT } from "./constants";
import Papa from 'papaparse';
import { prepareCSVContent } from './Download';
import { saveAs } from 'file-saver';

export const getImagesFromServer = async (params) => {
  try {
    const response = await fetch(`${API_URL}/api/generate-images`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add any additional headers like authentication if needed
        // 'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(params)
    });
    const data = await response.json();

    if (Array.isArray(data)) {
      return data.map((item) => ({
        url: item.image_data,
        prompt: item.prompt || "No prompt available",
        recordId: item.record_id || "N/A",
      }));
    } else if (data.image_data) {
      return [
        {
          url: data.image_data,
          prompt: data.prompt || "No prompt available",
          recordId: data.record_id || "N/A",
        },
      ];
    }
  } catch (error) {
    console.error("Error fetching images:", error);
    return [];
  }
};

export const loadDatasetContent = async (filename, token) => {
  try {

    const response = await fetch(`${API_URL}/api/datasets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        filename: filename
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to load dataset');
    }

    const csvText = await response.text();
    var columns = [];
    var results = [];

    Papa.parse(csvText, {
      header: true,
      dynamicTyping: true,
      complete: (compResults) => {
        results = compResults;
        const fields = results.meta?.fields || [];
        const hasRowId = fields.some(c => c && (c.toLowerCase() === 'rowid' || c.toLowerCase() === 'rowids' || c === '_rowId'));
        columns = [];
        if (!hasRowId) {
          columns.push({
            headerName: 'Row ID',
            valueGetter: 'node.rowIndex + 1',
            width: 75,
            pinned: 'left',
            sortable: true,
            filter: true,
            resizable: true,
            editable: false
          });
        }
        columns.push(...fields.map(field => ({
          field,
          sortable: true,
          filter: true,
          resizable: true,
          flex: 1,
          wrapText: true,
          autoHeight: true
        })));

        // setGridColumns(columns);
        // setGridData(results.data); // Show first 100 rows for preview
        // setIsDownloadDisabled(false);
      },
      error: (error) => {
        console.error('Error parsing CSV:', error);
        // toast.error('Error loading dataset preview');
      }
    });
    return ([columns, results.data]);
  } catch (error) {
    console.error('Error loading dataset:', error);
    // toast.error('Error loading dataset preview');
  }
};

export const submitFeedback = async (data, token) => {
  try {
    const headers = {
      'Content-Type': 'application/json'
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(`${API_URL}/api/submit-testimonial`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error submitting form:', error);
    // alert(error);
    throw error;
  }
};

export const requestDownload = async (data, user, filename = 'downloaded_') => {
  if (!user || !user.accessToken) return;
  try {
    const response = await fetch(`${API_URL}/api/request-download`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.accessToken}`
      },
      body: JSON.stringify({
        data: data,
        userId: user.uid,
        email: user.email,
        filename: filename,
        credits: 0
      })
    });
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error logging download request:', error);
  }
};

export const handleDownload = async (format, columns, rowData) => {
  if (format === 'csv') {
    const csvContent = prepareCSVContent(columns, rowData);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'dataset.csv');
  } else if (format === 'json') {
    const cleanRowData = Array.isArray(rowData)
      ? rowData.map((row, rowIndex) => {
          const hasRowIdCol = Object.keys(row).some(k => k.toLowerCase() === 'rowid' || k.toLowerCase() === 'rowids');
          if (!hasRowIdCol) {
            return { rowId: row._rowId || (rowIndex + 1), ...row };
          }
          return row;
        })
      : rowData;
    const jsonContent = JSON.stringify(cleanRowData, null, 2);
    const blob = new Blob([jsonContent], { type: 'application/json' });
    saveAs(blob, 'dataset.json');
  }
};


export const callPythonAPI = async (params) => {
  try {
    const response = await fetch(`${API_URL}/api/generate-detailed-prompt`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add any additional headers like authentication if needed
        // 'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      result: data["updatedPrompt"]
    };
  } catch (error) {
    console.error('Error calling Python API:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export const callClarificationAPI = async (chatMessages, currentInput, token) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_URL_AGENT}/api/ask-clarification`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        conversation_history: chatMessages,
        user_message: currentInput
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      result: data // backend returns { assistant_message, ready, conversation_history, error }
    };
  } catch (error) {
    console.error('Error calling Clarification API:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};